import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {fetchPaymentPageData} from "../../api/paymentPages/fetchPaymentPageData";
import PaymentPageForm from "./paymentPageForm";
import Loader from "../../loader";

function PaymentPageComponent() {
    const {'*': fullPath} = useParams();
    const ref = fullPath.split('_').pop();
    const parts = fullPath.split('-');
    const merchantPart = parts.find(part => part.startsWith('m_'));
    const merchantRef = merchantPart ? merchantPart.split('_')[1] : null;
    const [data, setData] = useState('');
    const [errorStatus, setErrorStatus] = useState(null);
    const [errorDetail, setErrorDetail] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const paymentPageData = await fetchPaymentPageData(ref, merchantRef);
                setData(paymentPageData);
                setIsDisabled(!paymentPageData?.is_active);

            } catch (error) {
                if (error?.response) {
                    setErrorStatus(error?.response?.status);
                    if (error?.response?.status === 404) {
                        setErrorDetail('Payment page not found');
                    } else {
                        setErrorDetail(error?.response?.data?.detail || 'An unexpected error occurred');
                    }
                } else {
                    setErrorStatus(error?.response?.status);
                    setErrorDetail(error?.message || 'An unexpected error occurred');
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="z-50 w-screen h-screen bg-white fixed inset-0 flex items-center justify-center">
                <Loader/>
            </div>
        );
    }

    if (isDisabled) {
        return (
            <div className="flex flex-col items-center justify-center h-screen">
                <div className="mt-4 mb-2 mx-auto">
                    <img
                        src="/hellopay.svg"
                        className="my-2 sm:mb-8 mx-auto w-auto h-[50px]"
                        alt={"logo"}
                    />
                    <img
                        src="/hellopayFailedIcon.svg"
                        className="mt-4 mb-2 mx-auto h-[200px] sm:h-[300px] w-auto"
                        alt={"logo"}
                    />
                </div>

                <div className="flex space-x-2 my-2 sm:mt-6 font-bold text-[32px] sm:text-[40px]">
                    <p className="text-center uppercase text-3xl font-bold tracking-wide">
                        <span className="text-black">Payment Page </span>
                        <span className="text-red">is disabled</span>
                    </p>
                </div>
            </div>
        );
    }

    if (errorStatus || errorDetail) {
        return (
            <div className="flex flex-col items-center justify-center h-screen">
                <div className="mt-4 mb-2 mx-auto">
                    <img
                        src="/hellopay.svg"
                        className="my-2 sm:mb-8 mx-auto w-auto h-[50px]"
                        alt={"logo"}
                    />
                    <img
                        src="/hellopayFailedIcon.svg"
                        className="mt-4 mb-2 mx-auto h-[200px] sm:h-[300px] w-auto"
                        alt={"logo"}
                    />
                </div>

                <div className="flex space-x-2 my-2 sm:mt-6 font-bold text-[32px] sm:text-[40px]">
                {errorStatus === 404 ? (
                    <div className="text-center uppercase text-3xl font-bold tracking-wide">
                        <p className="text-black">Payment Page </p>
                        <p className="text-red">not found</p>
                    </div>
                ) : (
                    <p className="text-red-500 text-center uppercase text-3xl font-bold tracking-wide">
                        {errorDetail}
                    </p>
                )}
                </div>
            </div>
        );
    }

    return (
        <div className="flex min-h-screen md:max-xl:flex">
            <div className="w-full flex columns-1 xl:columns-2 gap-1">
                <div className="pointer-events-none hidden xl:block w-1/2">
                    <img src="/hostedPageCardsBackgroundImage.svg"
                         className="h-[90vh] w-auto"
                         alt=""
                    />
                </div>
                <div className="w-full xl:w-1/2 flex item-center justify-center">
                    <div className="px-6 w-full text-xl xl:bg-[#F8F8F8] flex min-h-screen">
                        <div className="mx-auto mt-[2vh] w-full sm:w-3/4 md:w-2/3">
                            <div className="mt-2 mb-4 sm:mb-6 flex justify-center">
                                <img className="h-[10vh] w-auto"
                                     src="/hellopayPoweredByNedbank.svg"
                                     alt="hellopay powered by Nedbank"
                                />
                            </div>
                            <div className="mt-[5vh]">
                                <PaymentPageForm
                                    data={data}
                                    merchantRef={merchantRef}
                                    reference={ref}
                                    setIsLoading={setIsLoading}
                                    setErrorStatus={setErrorStatus}
                                    setErrorDetail={setErrorDetail}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PaymentPageComponent;